module.exports = __webpack_public_path__ + "img/m.45932bda.png";